import { useDispatch } from 'react-redux';

import LoginForm from '@/components/LoginForm';

import speedyFlowSlice from '../redux/slice';

const { advanceSpeedyFlow } = speedyFlowSlice.actions;

/**
 * The log-in step. Same form as the `/login` page, including the password-reset and magic-link
 * options, which the form brings with it.
 *
 * `isRealEmail` is passed straight through to the machine rather than acted on here: a returning
 * visitor whose address was never verified still owes us a verification, and the machine is what
 * knows whether that leads to a payment, a confirmation, or straight out.
 *
 * `persona` travels the same way and for a sharper reason: the machine's own copy was read when the
 * flow opened, from a signed-out visitor, so it is always false. Without the account's real answer
 * every returning user was asked a question they had answered years ago and then congratulated on
 * the free account they already had.
 */
const LogInStep = () => {
  const dispatch = useDispatch();

  return (
    <div className="flex flex-col p-6" data-component="speedy-step" data-step="log-in">
      <h2 className="preflight preflight-h2 mb-6 text-center text-2xl font-bold text-forest-dark">
        🌱 Welcome Back to Your Front Row Seat to the Wild
      </h2>
      <LoginForm
        trackingMethod="speedy-flow"
        onLoggedIn={({ isRealEmail, user }) =>
          dispatch(advanceSpeedyFlow({ type: 'signedInByEmail', isRealEmail, hasPersona: !!user?.persona }))
        }
        footer={
          <button
            type="button"
            className="preflight preflight-button mt-6 text-sm text-grey-3 underline hover:text-grey-2"
            onClick={() => dispatch(advanceSpeedyFlow({ type: 'choseSignUp' }))}
          >
            Don&apos;t have an account? Sign up
          </button>
        }
      />
    </div>
  );
};

export default LogInStep;
